import React, { useState } from 'react';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useNavigate } from "react-router-dom";
import moment from 'moment';
import Swal from "sweetalert2";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { storeEvents } from '../../Service';
import { setToken,setUserData } from '../../reducers/User/action';
import { useDispatch} from 'react-redux'



export default function AdminEditdetails(){
    const submitSuccess =false;

    
    const dispatch=useDispatch();
    const navigation = useNavigate();
    const initialValues = { event_status: "", start_date: "", end_date: "", event_type: "", event_name: "", event_location: "", schedule_date: "", rules_date: "", coi_date: "", shipping_date: "", catalog_date: "", boothdesign_date: "", badges_date: "", guestlist_date: "", finalpayment_date: "", programming_date: "", socialmedia_date: "", landingpage_date: "", virtualbooth_date: "", booth_map: "" };
    const [formValues, setFormValues] = useState(initialValues);
    const [formErrors, setFormErrors] = useState({});
    const [minstartDate, setStartDate] = useState('');

    const handleDateChange =(value, field)=>{
        console.log('field',field);
        setFormValues(prevState => ({
            ...prevState,
            [field]:  moment(value).format('YYYY-MM-DD')
        }));
    
       console.log('stat12', formValues);
    }

    const hanldeChange = (e) => {
        const value=e.target.value;
        const field=e.target.name;
        setFormValues(prevState => ({
        ...prevState,
        [field]: value }));
    }


		const handleSubmit = (e) => {
			e.preventDefault();
            console.log(formValues);
			const errorCount = validate(formValues);
			setFormErrors(errorCount);
            console.log(errorCount.status);
       
 
			if(errorCount.status){

				var bodyFormData = formValues;
                 console.log(bodyFormData);

                storeEvents(bodyFormData).then(res => handleResponse(res))

            }else{
				window.scrollTo(100, 100);
				return false;
			}
			



		}


        const handleResponse = (response) => {
            if(response.data.code==400){ //IF Token Expired......
                const errors = {};
                Swal.fire({
                  icon: 'error',
                  title: 'Oops...',
                  text: response.data.message,
                })
                errors.status = false;
                setFormErrors(errors);
              }else if(response.data.code==200){  //IF Request is Success
                const myinfo=[];
                Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: 'Event Added Successfully!',
                    showConfirmButton: false,
                    timer: 1500
                  })
                navigation("/eventlist");
              }
          }

		const validate = (values) => {
			const errors = {};
			errors.status = true;

			if(!values.event_name){
				errors.event_name = 'Event Name is required';
				errors.status = false;
			}

            if(!values.start_date){
				errors.start_date = 'Start Date is required';
				errors.status = false;
			}

            if(!values.end_date){
				errors.end_date = 'End Date is required';
				errors.status = false;
			}

            if(!values.event_type){
				errors.event_type = 'Event Type is required';
				errors.status = false;
			}

            if(!values.event_location){
				errors.event_location = 'Location is required';
				errors.status = false;
			}

			return errors;
		}

 return(
<section className="admin-section">
<div className="container">
<div className="row">
<div className="col-md-12 col-12">
<div className="admin-edit">
<h1>Add EVENT DETAILS</h1>
<Form onSubmit={handleSubmit} className="event-form">
    <Form.Group>
        <Form.Label>Active</Form.Label>
        <Form.Select aria-label="Default select example" defaultValue="{event_status}" name="event_status" onChange={hanldeChange} >
        <option value="2">Publish</option>
        <option value="1">Draft</option>
        </Form.Select>
    </Form.Group>
<Row>
    <Col>
    <Form.Group controlId="startdate">
    <Form.Label>Start Date <span className='star'>* </span></Form.Label>
    <DatePicker minDate={moment().toDate()} onChange={date => handleDateChange( date,'start_date')}  dateFormat="MM-DD-YYYY" placeholderText={'MM-DD-YYYY'} value={ formValues.start_date ? moment(formValues.start_date).format("MM-DD-YYYY") : '' } name="start_date" className='form-control' />
    
             
                <p className="error">{formErrors.start_date}</p>
                </Form.Group>
    </Col>
    <Col>
    <Form.Group controlId="enddate">
    <Form.Label>End Date <span className='star'>*</span></Form.Label>
    <DatePicker minDate={minstartDate} onChange={date => handleDateChange( date,'end_date')}  dateFormat="MM-DD-YYYY" placeholderText={'MM-DD-YYYY'} value={ formValues.end_date ? moment(formValues.end_date).format("MM-DD-YYYY") : '' } name="end_date" className='form-control' />
    
                <p className="error">{formErrors.end_date}</p>
                </Form.Group>
    </Col>
</Row>

<Row>
    <Col>
        <Form.Group>
            <Form.Label>Name <span className='star'>*</span></Form.Label>
            <Form.Control type="Name" name="event_name" defalutValue={formValues.event_name} placeholder="Name" onChange={hanldeChange} />
            <p className="error">{formErrors.event_name}</p>
        </Form.Group>
    </Col>
    <Col>
        <Form.Group>
            <Form.Label>Location <span className='star'>*</span></Form.Label>
            <Form.Control type="Name" name="event_location" defalutValue={formValues.event_location} placeholder="Location" onChange={hanldeChange} />
            <p className="error">{formErrors.event_location}</p>
        </Form.Group>
    </Col>
</Row>

<Form.Group>
        <Form.Label>Event Type <span className='star'>*</span></Form.Label>
        <Form.Select aria-label="Default select example" defalutValue={formValues.event_type} name="event_type" onChange={hanldeChange} >
        <option value="">-- Choose Event Type --</option>
        <option value="1">Physical</option>
        <option value="2">Online</option>
        </Form.Select>
        <p className="error">{formErrors.event_type}</p>
    </Form.Group>
<hr/>

<Row>
    <Col>
    <Form.Group controlId="startdate">
    <Form.Label>Apply By Date (Schedule) </Form.Label>
                <DatePicker minDate={moment().toDate()} onChange={date => handleDateChange( date,'schedule_date')}  dateFormat="MM-DD-YYYY" placeholderText={'MM-DD-YYYY'} value={ formValues.schedule_date ? moment(formValues.schedule_date).format("MM-DD-YYYY") : ''} name="schedule_date" className='form-control' />
                </Form.Group>
    </Col>
    <Col>
    <Form.Group controlId="enddate">
    <Form.Label>Apply By Date (Rules) </Form.Label>
                <DatePicker minDate={moment().toDate()} onChange={date => handleDateChange( date,'rules_date')}  dateFormat="MM-DD-YYYY" placeholderText={'MM-DD-YYYY'} value={ formValues.rules_date ? moment(formValues.rules_date).format("MM-DD-YYYY"): ''} name="rules_date" className='form-control' />
                </Form.Group>
    </Col>
</Row>

<Row>
    <Col>
    <Form.Group controlId="startdate">
    <Form.Label>Apply By Date (COI) </Form.Label>
                <DatePicker minDate={moment().toDate()} onChange={date => handleDateChange( date,'coi_date')}  dateFormat="MM-DD-YYYY" placeholderText={'MM-DD-YYYY'} value={ formValues.coi_date ? moment(formValues.coi_date).format("MM-DD-YYYY") : '' } name="coi_date" className='form-control' />
                </Form.Group>
    </Col>
    <Col>
    <Form.Group controlId="enddate">
    <Form.Label>Apply By Date (Shipping) </Form.Label>
                <DatePicker minDate={moment().toDate()} onChange={date => handleDateChange( date,'shipping_date')}  dateFormat="MM-DD-YYYY" placeholderText={'MM-DD-YYYY'} value={ formValues.shipping_date ? moment(formValues.shipping_date).format("MM-DD-YYYY") : '' } name="shipping_date" className='form-control' />
                </Form.Group>
    </Col>
</Row>

<Row>
    <Col>
    <Form.Group controlId="startdate">
    <Form.Label>Apply By Date (Catalog) </Form.Label>
                <DatePicker minDate={moment().toDate()} onChange={date => handleDateChange( date,'catalog_date')}  dateFormat="MM-DD-YYYY" placeholderText={'MM-DD-YYYY'} value={ formValues.catalog_date ? moment(formValues.catalog_date).format("MM-DD-YYYY") : '' } name="catalog_date" className='form-control' />
                </Form.Group>
    </Col>
    <Col>
    <Form.Group controlId="enddate">
    <Form.Label>Apply By Date (Booth Design) </Form.Label>
                <DatePicker minDate={moment().toDate()} onChange={date => handleDateChange( date,'boothdesign_date')}  dateFormat="MM-DD-YYYY" placeholderText={'MM-DD-YYYY'} value={ formValues.boothdesign_date ? moment(formValues.boothdesign_date).format("MM-DD-YYYY") : '' } name="boothdesign_date" className='form-control' />
                </Form.Group>
    </Col>
</Row>

<Row>
    <Col>
    <Form.Group controlId="startdate">
    <Form.Label>Apply By Date (Badges) </Form.Label>
                <DatePicker minDate={moment().toDate()} onChange={date => handleDateChange( date,'badges_date')}  dateFormat="MM-DD-YYYY" placeholderText={'MM-DD-YYYY'} value={ formValues.badges_date ? moment(formValues.badges_date).format("MM-DD-YYYY") : '' } name="badges_date" className='form-control' />
                </Form.Group>
    </Col>
    <Col>
    <Form.Group controlId="enddate">
    <Form.Label>Apply By Date (Guest List) </Form.Label>
                <DatePicker minDate={moment().toDate()} onChange={date => handleDateChange( date,'guestlist_date')}  dateFormat="MM-DD-YYYY" placeholderText={'MM-DD-YYYY'} value={ formValues.guestlist_date ? moment(formValues.guestlist_date).format("MM-DD-YYYY") : '' } name="guestlist_date" className='form-control' />
                </Form.Group>
    </Col>
</Row>

<Row>
    <Col>
    <Form.Group controlId="startdate">
    <Form.Label>Apply By Date (Final Payment) </Form.Label>
                <DatePicker minDate={moment().toDate()} onChange={date => handleDateChange( date,'finalpayment_date')}  dateFormat="MM-DD-YYYY" placeholderText={'MM-DD-YYYY'} value={ formValues.finalpayment_date ? moment(formValues.finalpayment_date).format("MM-DD-YYYY") : '' } name="finalpayment_date" className='form-control' />
                </Form.Group>
    </Col>
    <Col>
    <Form.Group controlId="enddate">
    <Form.Label>Apply By Date (Programming Date) </Form.Label>
                <DatePicker minDate={moment().toDate()} onChange={date => handleDateChange( date,'programming_date')}  dateFormat="MM-DD-YYYY" placeholderText={'MM-DD-YYYY'} value={ formValues.programming_date ? moment(formValues.programming_date).format("MM-DD-YYYY") : '' } name="programming_date" className='form-control' />
                </Form.Group>
    </Col>
     
</Row>

<Row>
    <Col>
    <Form.Group controlId="startdate">
    <Form.Label>Apply By Date (Socialmedia Date) </Form.Label>
                <DatePicker minDate={moment().toDate()} onChange={date => handleDateChange( date,'socialmedia_date')}  dateFormat="MM-DD-YYYY" placeholderText={'MM-DD-YYYY'} value={ formValues.socialmedia_date ? moment(formValues.socialmedia_date).format("MM-DD-YYYY") : '' } name="socialmedia_date" className='form-control' />
                </Form.Group>
    </Col>
    <Col>
    <Form.Group controlId="enddate">
    <Form.Label>Apply By Date (Landingpage Date) </Form.Label>
                <DatePicker minDate={moment().toDate()} onChange={date => handleDateChange( date,'landingpage_date')}  dateFormat="MM-DD-YYYY" placeholderText={'MM-DD-YYYY'} value={ formValues.landingpage_date ? moment(formValues.landingpage_date).format("MM-DD-YYYY") : '' } name="landingpage_date" className='form-control' />
                </Form.Group>
    </Col>
     
</Row>

<Row>
    <Col>
    <Form.Group controlId="startdate">
    <Form.Label>Apply By Date (Virtualbooth Date) </Form.Label>
                <DatePicker minDate={moment().toDate()} onChange={date => handleDateChange( date,'virtualbooth_date')}  dateFormat="MM-DD-YYYY" placeholderText={'MM-DD-YYYY'} value={ formValues.virtualbooth_date ? moment(formValues.virtualbooth_date).format("MM-DD-YYYY") : '' } name="virtualbooth_date" className='form-control' />
                </Form.Group>
    </Col>
    <Col>
    </Col>
     
</Row>


    <Button variant="primary" type="submit" className='submit' onClick={handleSubmit} >
        Submit
    </Button>
</Form>
</div>
</div>
</div>
</div>
</section>
)
}